import request from '@/utils/request'
const apiPath = '/cust_service/custServiceAutoReply'
import { downloadBlob } from '@/utils/download'
const custServiceAutoReplyApi = {
  /**
   * 新增【客服自动回复】
   */
  create(data) {
    return request.post(apiPath + '/tee', data)
  },
  /**
   * 修改【客服自动回复】
   */
  update(data) {
    return request.put(apiPath + '/tee', data)
  },
  /**
   * 分页查询【客服自动回复】
   */
  fetchList(query) {
    return request.get(apiPath + '/tee', { params: query })
  },
  findOptions(query) {
    return request.get(`${apiPath}/options`, { params: query })
  },
  /**
   * 查看【客服自动回复】详情
   */
  fetchById(id) {
    return request.get(`${apiPath}/${id}`)
  },
  /**
   * 删除单个【客服自动回复】
   */
  deleteById(id) {
    return request.delete(`${apiPath}/${id}`)
  },
  setIsEnable(data) {
    return request.put(apiPath + '/tee/setIsEnable', data)
  },
  exportExcel(query) {
    return request.get(`${apiPath}/export`, { responseType: 'blob', params: query })
      .then(res => downloadBlob(res, '客服自动回复.xlsx'))
  },
}
export default custServiceAutoReplyApi
